"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAccountingPaidApiResponseSchema = exports.setAccountingPaidApiPayloadSchema = void 0;
const zod_1 = require("zod");
exports.setAccountingPaidApiPayloadSchema = zod_1.z.object({
    paid: zod_1.z.boolean(),
});
exports.setAccountingPaidApiResponseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    paid: zod_1.z.boolean(),
});
